
export const eventsData = [
    {
        month: 'January',
        year: 2026,
        events: [
            {
                id: 'aus-open-2026',
                name: 'Australian Open 2026',
                startDate: '1/12/2026',
                endDate: '2/1/2026',
                category: 'tennis',
                url: 'https://ausopen.com',
                venue: 'Melbourne Park, Australia',
                description: 'The Happy Slam kicks off the tennis season.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'arsenal-liverpool-jan-2026',
                name: 'Arsenal v Liverpool',
                startDate: '1/3/2026',
                category: 'football',
                url: 'https://www.arsenal.com',
                venue: 'Emirates Stadium, London',
                description: 'Premier League clash.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'darts-final-2026',
                name: 'World Darts Championship Final',
                startDate: '1/3/2026',
                category: 'darts',
                url: 'https://www.pdc.tv',
                venue: 'Alexandra Palace, London',
                description: 'The biggest night in darts.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'mancity-chelsea-jan-2026',
                name: 'Manchester City v Chelsea',
                startDate: '1/3/2026',
                category: 'football',
                url: 'https://www.mancity.com',
                venue: 'Etihad Stadium, Manchester',
                description: 'Heavyweight Premier League battle.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'cirque-ovo-2026',
                name: 'Cirque du Soleil: OVO',
                startDate: '1/12/2026',
                endDate: '2/1/2026',
                category: 'entertainment',
                url: 'https://www.cirquedusoleil.com/ovo',
                venue: 'Royal Albert Hall, London',
                description: 'A spectacular acrobatic journey into the insect world.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'spurs-westham-jan-2026',
                name: 'Tottenham Hotspur v West Ham United',
                startDate: '1/17/2026',
                category: 'football',
                url: 'https://www.tottenhamhotspur.com',
                venue: 'Tottenham Hotspur Stadium, London',
                description: 'London derby.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'manutd-mancity-jan-2026',
                name: 'Manchester United v Manchester City',
                startDate: '1/17/2026',
                category: 'football',
                url: 'https://www.manutd.com',
                venue: 'Old Trafford, Manchester',
                description: 'The Manchester Derby.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'nba-london-2026',
                name: 'NBA London Game 2026',
                startDate: '1/18/2026',
                category: 'basketball',
                url: 'https://www.nba.com',
                venue: 'The O2 Arena, London',
                description: 'NBA regular season game in London.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'peter-kay-jan-2026',
                name: 'Peter Kay Live',
                startDate: '1/23/2026',
                category: 'entertainment',
                url: 'https://www.utilitaarenacardiff.co.uk',
                venue: 'Utilita Arena, Cardiff',
                description: 'Legendary comedian Peter Kay live.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'arsenal-manutd-jan-2026',
                name: 'Arsenal v Manchester United',
                startDate: '1/24/2026',
                category: 'football',
                url: 'https://www.arsenal.com',
                venue: 'Emirates Stadium, London',
                description: 'Classic Premier League rivalry.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'liverpool-newcastle-jan-2026',
                name: 'Liverpool v Newcastle United',
                startDate: '1/28/2026',
                category: 'football',
                url: 'https://www.liverpoolfc.com',
                venue: 'Anfield, Liverpool',
                description: 'Premier League fixture.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'spurs-mancity-jan-2026',
                name: 'Tottenham Hotspur v Manchester City',
                startDate: '1/31/2026',
                category: 'football',
                url: 'https://www.tottenhamhotspur.com',
                venue: 'Tottenham Hotspur Stadium, London',
                description: 'Premier League clash.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'jason-derulo-jan-2026',
                name: 'Jason Derulo: The Last Dance World Tour',
                startDate: '1/31/2026',
                category: 'entertainment',
                url: 'https://www.jasonderulo.com',
                venue: 'Hill Dickinson Stadium',
                description: 'Global superstar Jason Derulo live.',
                status: 'upcoming',
                ticketsAvailable: true
            }
        ]
    },
    {
        month: 'February',
        year: 2026,
        events: [
            {
                id: 'super-league-basketball-2026',
                name: 'Super League Basketball Trophy Finals',
                startDate: '2/1/2026',
                category: 'basketball',
                url: 'https://www.utilitaarenabham.co.uk',
                venue: 'Utilita Arena, Birmingham',
                description: 'Basketball trophy finals.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'jason-derulo-feb-2026',
                name: 'Jason Derulo: The Last Dance',
                startDate: '2/7/2026',
                category: 'entertainment',
                url: 'https://www.cooplive.com',
                venue: 'Co-op Live, Manchester',
                description: 'Jason Derulo live in Manchester.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'liverpool-mancity-feb-2026',
                name: 'Liverpool v Manchester City',
                startDate: '2/7/2026',
                category: 'football',
                url: 'https://www.liverpoolfc.com',
                venue: 'Anfield, Liverpool',
                description: 'Title contenders clash.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'manutd-spurs-feb-2026',
                name: 'Manchester United v Tottenham Hotspur',
                startDate: '2/7/2026',
                category: 'football',
                url: 'https://www.manutd.com',
                venue: 'Old Trafford, Manchester',
                description: 'Premier League battle.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'icc-t20-wc-2026',
                name: 'ICC Men’s T20 World Cup',
                startDate: '2/8/2026',
                endDate: '3/1/2026',
                category: 'cricket',
                url: 'https://www.icc-cricket.com',
                venue: 'India & Sri Lanka',
                description: 'The pinnacle of T20 cricket.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'super-bowl-2026',
                name: 'Super Bowl LX',
                startDate: '2/8/2026',
                category: 'entertainment',
                url: 'https://www.nfl.com/super-bowl',
                venue: 'Levi Stadium, Santa Clara, CA',
                description: 'The biggest sporting event in America.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'ascot-race-day-feb-2026',
                name: 'Betfair Ascot Race Day',
                startDate: '2/14/2026',
                category: 'horseracing',
                url: 'https://www.ascot.com',
                venue: 'Ascot Racecourse, Berkshire',
                description: 'Premier horse racing event.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'florence-machine-feb-2026',
                name: 'Florence + The Machine',
                startDate: '2/16/2026',
                endDate: '2/17/2026',
                category: 'entertainment',
                url: 'https://www.theo2.co.uk',
                venue: 'The O2 Arena, London',
                description: 'Florence Welch and her band live.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'james-arthur-feb-2026',
                name: 'James Arthur: The Pisces World Tour',
                startDate: '2/18/2026',
                endDate: '2/19/2026',
                category: 'entertainment',
                url: 'https://www.theo2.co.uk',
                venue: 'The O2 Arena, London',
                description: 'James Arthur live in concert.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'mancity-newcastle-feb-2026',
                name: 'Manchester City v Newcastle United',
                startDate: '2/21/2026',
                category: 'football',
                url: 'https://www.mancity.com',
                venue: 'Etihad Stadium, Manchester',
                description: 'Premier League fixture.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'spurs-arsenal-feb-2026',
                name: 'Tottenham Hotspur v Arsenal',
                startDate: '2/21/2026',
                category: 'football',
                url: 'https://www.tottenhamhotspur.com',
                venue: 'Tottenham Hotspur Stadium, London',
                description: 'North London Derby.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'arsenal-chelsea-feb-2026',
                name: 'Arsenal v Chelsea',
                startDate: '2/28/2026',
                category: 'football',
                url: 'https://www.arsenal.com',
                venue: 'Emirates Stadium, London',
                description: 'London rivalry.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'brit-awards-2026',
                name: 'The BRIT Awards 2026',
                startDate: '2/28/2026',
                category: 'entertainment',
                url: 'https://www.brits.co.uk',
                venue: 'Co-op Live, Manchester',
                description: 'The UK\'s biggest music awards.',
                status: 'upcoming',
                ticketsAvailable: true
            }
        ]
    },
    {
        month: 'March',
        year: 2026,
        events: [
            {
                id: 'ipl-2026',
                name: 'IPL 2026',
                startDate: '3/1/2026',
                endDate: '5/31/2026',
                category: 'cricket',
                url: 'https://www.iplt20.com',
                venue: 'India',
                description: 'The world\'s premier T20 league.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'spurs-palace-mar-2026',
                name: 'Tottenham Hotspur v Crystal Palace',
                startDate: '3/4/2026',
                category: 'football',
                url: 'https://www.tottenhamhotspur.com',
                venue: 'Tottenham Hotspur Stadium, London',
                description: 'Premier League fixture.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'mancity-forest-mar-2026',
                name: 'Manchester City v Nottingham Forest',
                startDate: '3/4/2026',
                category: 'football',
                url: 'https://www.mancity.com',
                venue: 'Etihad Stadium, Manchester',
                description: 'Premier League fixture.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'australian-gp-2026',
                name: 'Australian Grand Prix',
                startDate: '3/5/2026',
                endDate: '3/8/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Australia.html',
                venue: 'Albert Park Circuit, Melbourne',
                description: 'F1 season opener.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'villa-chelsea-mar-2026',
                name: 'Aston Villa v Chelsea',
                startDate: '3/6/2026',
                category: 'football',
                url: 'https://www.avfc.co.uk',
                venue: 'Villa Park, Birmingham',
                description: 'Premier League fixture.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'cheltenham-2026',
                name: 'Cheltenham Festival',
                startDate: '3/10/2026',
                endDate: '3/13/2026',
                category: 'horseracing',
                url: 'https://www.thejockeyclub.co.uk/cheltenham',
                venue: 'Cheltenham Racecourse',
                description: 'The pinnacle of Jump racing.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'chinese-gp-2026',
                name: 'Chinese Grand Prix',
                startDate: '3/13/2026',
                endDate: '3/15/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/China.html',
                venue: 'Shanghai International Circuit',
                description: 'F1 returns to Shanghai.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'liverpool-spurs-mar-2026',
                name: 'Liverpool v Tottenham Hotspur',
                startDate: '3/14/2026',
                category: 'football',
                url: 'https://www.liverpoolfc.com',
                venue: 'Anfield, Liverpool',
                description: 'Premier League clash.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'chelsea-newcastle-mar-2026',
                name: 'Chelsea v Newcastle United',
                startDate: '3/14/2026',
                category: 'football',
                url: 'https://www.chelseafc.com',
                venue: 'Stamford Bridge, London',
                description: 'Premier League fixture.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'arsenal-everton-mar-2026',
                name: 'Arsenal v Everton',
                startDate: '3/14/2026',
                category: 'football',
                url: 'https://www.arsenal.com',
                venue: 'Emirates Stadium, London',
                description: 'Premier League fixture.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'carabao-cup-final-2026',
                name: 'Carabao Cup Final',
                startDate: '3/22/2026',
                category: 'football',
                url: 'https://www.efl.com',
                venue: 'Wembley Stadium, London',
                description: 'League Cup Final.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'japanese-gp-2026',
                name: 'Japanese Grand Prix',
                startDate: '3/26/2026',
                endDate: '3/29/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Japan.html',
                venue: 'Suzuka Circuit',
                description: 'Iconic figure-8 circuit.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'richard-ashcroft-mar-2026',
                name: 'Richard Ashcroft',
                startDate: '3/28/2026',
                category: 'entertainment',
                url: 'https://www.theo2.co.uk',
                venue: 'The O2 Arena, London',
                description: 'The Verve legend live.',
                status: 'upcoming',
                ticketsAvailable: true
            }
        ]
    },
    {
        month: 'April',
        year: 2026,
        events: [
            {
                id: 'the-masters-2026',
                name: 'The Masters',
                startDate: '4/9/2026',
                endDate: '4/12/2026',
                category: 'golf',
                url: 'https://www.masters.com',
                venue: 'Augusta National Golf Club, USA',
                description: 'The first major of the golf year.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'grand-national-2026',
                name: 'Randox Grand National',
                startDate: '4/9/2026',
                endDate: '4/11/2026',
                category: 'horseracing',
                url: 'https://www.thejockeyclub.co.uk/aintree',
                venue: 'Aintree Racecourse, Liverpool',
                description: 'The world\'s most famous steeplechase.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'bahrain-gp-2026',
                name: 'Bahrain Grand Prix',
                startDate: '4/9/2026',
                endDate: '4/12/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Bahrain.html',
                venue: 'Bahrain International Circuit',
                description: 'Night race in the desert.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'arsenal-bournemouth-apr-2026',
                name: 'Arsenal v Bournemouth',
                startDate: '4/11/2026',
                category: 'football',
                url: 'https://www.arsenal.com',
                venue: 'Emirates Stadium, London',
                description: 'Premier League fixture.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'chelsea-mancity-apr-2026',
                name: 'Chelsea v Manchester City',
                startDate: '4/11/2026',
                category: 'football',
                url: 'https://www.chelseafc.com',
                venue: 'Stamford Bridge, London',
                description: 'Premier League blockbuster.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'salon-prive-2026',
                name: 'Salon Privé London',
                startDate: '4/16/2026',
                endDate: '4/18/2026',
                category: 'entertainment',
                url: 'https://www.salonprivelondon.com',
                venue: 'Royal Hospital Chelsea, London',
                description: 'Luxury automotive event.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'saudi-gp-2026',
                name: 'Saudi Arabian Grand Prix',
                startDate: '4/16/2026',
                endDate: '4/19/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Saudi_Arabia.html',
                venue: 'Jeddah Corniche Circuit',
                description: 'Fastest street circuit in F1.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'spurs-brighton-apr-2026',
                name: 'Tottenham Hotspur v Brighton',
                startDate: '4/18/2026',
                category: 'football',
                url: 'https://www.tottenhamhotspur.com',
                venue: 'Tottenham Hotspur Stadium, London',
                description: 'Premier League fixture.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'mancity-arsenal-apr-2026',
                name: 'Manchester City v Arsenal',
                startDate: '4/18/2026',
                category: 'football',
                url: 'https://www.mancity.com',
                venue: 'Etihad Stadium, Manchester',
                description: 'Potential title decider.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'fa-cup-semi-1-2026',
                name: 'FA Cup Semi-Final 1',
                startDate: '4/25/2026',
                category: 'football',
                url: 'https://www.thefa.com',
                venue: 'Wembley Stadium, London',
                description: 'The road to glory continues.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'rick-astley-apr-2026',
                name: 'Rick Astley Live',
                startDate: '4/25/2026',
                category: 'entertainment',
                url: 'https://www.theo2.co.uk',
                venue: 'The O2 Arena, London',
                description: 'Rick Astley in concert.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'fa-cup-semi-2-2026',
                name: 'FA Cup Semi-Final 2',
                startDate: '4/26/2026',
                category: 'football',
                url: 'https://www.thefa.com',
                venue: 'Wembley Stadium, London',
                description: 'The second semi-final showdown.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'olivia-dean-apr-2026',
                name: 'Olivia Dean: The Art of Loving Live',
                startDate: '4/29/2026',
                endDate: '5/2/2026',
                category: 'entertainment',
                url: 'https://www.theo2.co.uk',
                venue: 'The O2 Arena, London',
                description: 'Rising star Olivia Dean live.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'miami-gp-2026',
                name: 'Miami Grand Prix',
                startDate: '4/30/2026',
                endDate: '5/3/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Miami.html',
                venue: 'Miami International Autodrome',
                description: 'F1 glamour in Miami.',
                status: 'upcoming',
                ticketsAvailable: true
            }
        ]
    },
    {
        month: 'May',
        year: 2026,
        events: [
            {
                id: 'chelsea-forest-may-2026',
                name: 'Chelsea v Nottingham Forest',
                startDate: '5/2/2026',
                category: 'football',
                url: 'https://www.chelseafc.com',
                venue: 'Stamford Bridge, London',
                description: 'Premier League fixture.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'manutd-liverpool-may-2026',
                name: 'Manchester United v Liverpool',
                startDate: '5/2/2026',
                category: 'football',
                url: 'https://www.manutd.com',
                venue: 'Old Trafford, Manchester',
                description: 'Historic rivalry match.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'liverpool-chelsea-may-2026',
                name: 'Liverpool v Chelsea',
                startDate: '5/9/2026',
                category: 'football',
                url: 'https://www.liverpoolfc.com',
                venue: 'Anfield, Liverpool',
                description: 'Premier League classic.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'emilia-romagna-gp-2026',
                name: 'Emilia Romagna Grand Prix',
                startDate: '5/14/2026',
                endDate: '5/17/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Emilia_Romagna.html',
                venue: 'Imola Circuit, Italy',
                description: 'Racing at iconic Imola.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'fa-cup-final-2026',
                name: 'FA Cup Final',
                startDate: '5/17/2026',
                category: 'football',
                url: 'https://www.thefa.com',
                venue: 'Wembley Stadium, London',
                description: 'The showpiece final of the English season.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'villa-liverpool-may-2026',
                name: 'Aston Villa v Liverpool',
                startDate: '5/17/2026',
                category: 'football',
                url: 'https://www.avfc.co.uk',
                venue: 'Villa Park, Birmingham',
                description: 'Premier League season finale.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'manutd-forest-may-2026',
                name: 'Manchester United v Nottingham Forest',
                startDate: '5/17/2026',
                category: 'football',
                url: 'https://www.manutd.com',
                venue: 'Old Trafford, Manchester',
                description: 'Premier League season finale.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'french-open-2026',
                name: 'French Open (Roland-Garros)',
                startDate: '5/18/2026',
                endDate: '6/7/2026',
                category: 'tennis',
                url: 'https://www.rolandgarros.com',
                venue: 'Roland Garros, Paris',
                description: 'The sole clay court Grand Slam.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'canadian-gp-2026',
                name: 'Canadian Grand Prix',
                startDate: '5/22/2026',
                endDate: '5/24/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Canada.html',
                venue: 'Circuit Gilles Villeneuve, Montreal',
                description: 'A fan favorite.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'championship-playoff-2026',
                name: 'Championship Play-off Final',
                startDate: '5/23/2026',
                category: 'football',
                url: 'https://www.efl.com',
                venue: 'Wembley Stadium, London',
                description: 'The richest game in football.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'league-one-playoff-2026',
                name: 'League One Play-off Final',
                startDate: '5/24/2026',
                category: 'football',
                url: 'https://www.efl.com',
                venue: 'Wembley Stadium, London',
                description: 'Battle for promotion.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'ucl-final-2026',
                name: 'UEFA Champions League Final',
                startDate: '5/30/2026',
                category: 'football',
                url: 'https://www.uefa.com',
                venue: 'Puskas Arena, Budapest',
                description: 'Europe\'s elite club final.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'film-music-gala-2026',
                name: 'Film Music Gala',
                startDate: '5/30/2026',
                category: 'entertainment',
                url: 'https://www.royalalberthall.com',
                venue: 'Royal Albert Hall, London',
                description: 'A celebration of cinematic scores.',
                status: 'upcoming',
                ticketsAvailable: true
            }
        ]
    },
    {
        month: 'June',
        year: 2026,
        events: [
            {
                id: 'fifa-wc-2026',
                name: 'FIFA World Cup 2026',
                startDate: '6/1/2026',
                endDate: '7/19/2026',
                category: 'football',
                url: 'https://www.fifa.com',
                venue: 'USA, Canada, Mexico',
                description: 'The world\'s biggest sporting event.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'eng-nz-test-2026',
                name: 'England v New Zealand Test Match',
                startDate: '6/4/2026',
                endDate: '6/8/2026',
                category: 'cricket',
                url: 'https://www.ecb.co.uk',
                venue: 'Lord\'s Cricket Ground, London',
                description: 'Summer test cricket at the Home of Cricket.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'monaco-gp-2026',
                name: 'Monaco Grand Prix',
                startDate: '6/4/2026',
                endDate: '6/7/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Monaco.html',
                venue: 'Circuit de Monaco',
                description: 'Glitz, glamour and racing.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'queens-wta-2026',
                name: 'WTA500 HSBC Queen’s Club Championships',
                startDate: '6/8/2026',
                endDate: '6/14/2026',
                category: 'tennis',
                url: 'https://www.lta.org.uk',
                venue: 'The Queen\'s Club, London',
                description: 'Premier women\'s grass court tournament.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'icc-womens-t20-2026',
                name: 'ICC Women\'s T20 World Cup',
                startDate: '6/12/2026',
                endDate: '7/5/2026',
                category: 'cricket',
                url: 'https://www.icc-cricket.com',
                venue: 'England & Wales',
                description: 'World championship cricket.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'spanish-gp-2026',
                name: 'Spanish Grand Prix',
                startDate: '6/12/2026',
                endDate: '6/14/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Spain.html',
                venue: 'Circuit de Barcelona-Catalunya',
                description: 'European F1 staple.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'queens-atp-2026',
                name: 'ATP500 HSBC Queen’s Club Championships',
                startDate: '6/15/2026',
                endDate: '6/21/2026',
                category: 'tennis',
                url: 'https://www.lta.org.uk',
                venue: 'The Queen\'s Club, London',
                description: 'Traditional warm-up for Wimbledon.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'royal-ascot-2026',
                name: 'Royal Ascot',
                startDate: '6/16/2026',
                endDate: '6/20/2026',
                category: 'horseracing',
                url: 'https://www.ascot.com',
                venue: 'Ascot Racecourse',
                description: 'Britain\'s most valuable race meeting.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'premiership-rugby-final-2026',
                name: 'Gallagher Premiership Rugby Final',
                startDate: '6/20/2026',
                category: 'rugby',
                url: 'https://www.premiershiprugby.com',
                venue: 'Allianz Stadium, Twickenham',
                description: 'The climax of the English rugby season.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'giorgio-armani-tennis-2026',
                name: 'Giorgio Armani Tennis Classic',
                startDate: '6/23/2026',
                endDate: '6/27/2026',
                category: 'tennis',
                url: 'https://www.giorgioarmanitennisclassic.com',
                venue: 'Hurlingham Club, London',
                description: 'Exhibition tennis in a stunning setting.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'austrian-gp-2026',
                name: 'Austrian Grand Prix',
                startDate: '6/26/2026',
                endDate: '6/28/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Austria.html',
                venue: 'Red Bull Ring',
                description: 'Short and fast track action.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'wimbledon-2026',
                name: 'Wimbledon Championships',
                startDate: '6/29/2026',
                endDate: '7/12/2026',
                category: 'tennis',
                url: 'https://www.wimbledon.com',
                venue: 'All England Club, London',
                description: 'The most prestigious tennis tournament.',
                status: 'upcoming',
                ticketsAvailable: true
            }
        ]
    },
    {
        month: 'July',
        year: 2026,
        events: [
            {
                id: 'henley-regatta-2026',
                name: 'Henley Royal Regatta',
                startDate: '6/30/2026',
                endDate: '7/5/2026',
                category: 'entertainment',
                url: 'https://www.hrr.co.uk',
                venue: 'Henley-on-Thames',
                description: 'World-famous rowing event.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'def-leppard-jul-2026',
                name: 'Def Leppard',
                startDate: '7/2/2026',
                category: 'entertainment',
                url: 'https://www.theo2.co.uk',
                venue: 'The O2 Arena, London',
                description: 'Rock legends live.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'british-gp-2026',
                name: 'British Grand Prix',
                startDate: '7/3/2026',
                endDate: '7/5/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Great_Britain.html',
                venue: 'Silverstone Circuit',
                description: 'The home of British motorsport.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'metallica-jul-2026',
                name: 'Metallica',
                startDate: '7/3/2026',
                endDate: '7/5/2026',
                category: 'entertainment',
                url: 'https://www.metallica.com',
                venue: 'London Stadium',
                description: 'Heavy metal icons.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'scottish-open-2026',
                name: 'Genesis Scottish Open',
                startDate: '7/8/2026',
                endDate: '7/12/2026',
                category: 'golf',
                url: 'https://www.europeantour.com',
                venue: 'The Renaissance Club',
                description: 'Premier golf tournament.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'goodwood-fos-2026',
                name: 'Goodwood Festival of Speed',
                startDate: '7/9/2026',
                endDate: '7/12/2026',
                category: 'entertainment',
                url: 'https://www.goodwood.com',
                venue: 'Goodwood Estate',
                description: 'Motorsport garden party.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'mcr-jul-2026',
                name: 'My Chemical Romance',
                startDate: '7/10/2026',
                endDate: '7/11/2026',
                category: 'entertainment',
                url: 'https://www.wembleystadium.com',
                venue: 'Wembley Stadium, London',
                description: 'Emo legends return.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'the-open-2026',
                name: 'The Open Championship',
                startDate: '7/12/2026',
                endDate: '7/19/2026',
                category: 'golf',
                url: 'https://www.theopen.com',
                venue: 'Royal Birkdale',
                description: 'Golf\'s oldest major.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'belgian-gp-2026',
                name: 'Belgian Grand Prix',
                startDate: '7/17/2026',
                endDate: '7/19/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Belgium.html',
                venue: 'Spa-Francorchamps',
                description: 'The driver\'s favorite track.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'eng-india-odi-2026',
                name: 'England v India ODI',
                startDate: '7/19/2026',
                category: 'cricket',
                url: 'https://www.ecb.co.uk',
                venue: 'Lord\'s Cricket Ground, London',
                description: 'One Day International action.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'hungarian-gp-2026',
                name: 'Hungarian Grand Prix',
                startDate: '7/23/2026',
                endDate: '7/26/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Hungary.html',
                venue: 'Hungaroring',
                description: 'Technical and twisty.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'qatar-goodwood-2026',
                name: 'Qatar Goodwood Festival',
                startDate: '7/28/2026',
                endDate: '8/1/2026',
                category: 'horseracing',
                url: 'https://www.goodwood.com',
                venue: 'Goodwood Racecourse',
                description: 'Glorious Goodwood.',
                status: 'upcoming',
                ticketsAvailable: true
            }
        ]
    },
    {
        month: 'August',
        year: 2026,
        events: [
            {
                id: 'cowes-week-2026',
                name: 'Cowes Week',
                startDate: '8/1/2026',
                endDate: '8/7/2026',
                category: 'entertainment',
                url: 'https://www.cowesweek.co.uk',
                venue: 'Isle of Wight',
                description: 'Sailing regatta.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'motogp-britain-2026',
                name: 'British MotoGP',
                startDate: '8/7/2026',
                endDate: '8/9/2026',
                category: 'formula1',
                url: 'https://www.motogp.com',
                venue: 'Silverstone Circuit',
                description: 'Premier motorcycle racing.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'shergar-cup-2026',
                name: 'Dubai Duty Free Shergar Cup',
                startDate: '8/8/2026',
                category: 'horseracing',
                url: 'https://www.ascot.com',
                venue: 'Ascot Racecourse',
                description: 'Unique team racing event.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'weeknd-aug-2026',
                name: 'The Weeknd',
                startDate: '8/14/2026',
                endDate: '8/15/2026',
                category: 'entertainment',
                url: 'https://www.wembleystadium.com',
                venue: 'Wembley Stadium, London',
                description: 'Global pop superstar.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'ariana-grande-aug-2026',
                name: 'Ariana Grande: Eternal Sunshine',
                startDate: '8/15/2026',
                endDate: '8/21/2026',
                category: 'entertainment',
                url: 'https://www.theo2.co.uk',
                venue: 'The O2 Arena, London',
                description: 'Ariana Grande live.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'london-eprix-2026',
                name: 'London E-Prix',
                startDate: '8/15/2026',
                endDate: '8/16/2026',
                category: 'formula1',
                url: 'https://www.fiaformulae.com',
                venue: 'ExCeL London',
                description: 'Electric street racing.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'ebor-festival-2026',
                name: 'Ebor Festival',
                startDate: '8/19/2026',
                endDate: '8/22/2026',
                category: 'horseracing',
                url: 'https://www.yorkracecourse.co.uk',
                venue: 'York Racecourse',
                description: 'Historic racing festival.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'dutch-gp-2026',
                name: 'Dutch Grand Prix',
                startDate: '8/20/2026',
                endDate: '8/23/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Netherlands.html',
                venue: 'Zandvoort',
                description: 'The Orange Army awaits.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'epsom-aug-2026',
                name: 'Bank Holiday Family Raceday',
                startDate: '8/31/2026',
                category: 'horseracing',
                url: 'https://www.thejockeyclub.co.uk/epsom',
                venue: 'Epsom Downs',
                description: 'Family racing fun.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'us-open-2026',
                name: 'US Open Tennis',
                startDate: '8/31/2026',
                endDate: '9/13/2026',
                category: 'tennis',
                url: 'https://www.usopen.org',
                venue: 'New York, USA',
                description: 'Grand Slam tennis in NYC.',
                status: 'upcoming',
                ticketsAvailable: true
            }
        ]
    },
    {
        month: 'September',
        year: 2026,
        events: [
            {
                id: 'italian-gp-2026',
                name: 'Italian Grand Prix',
                startDate: '9/4/2026',
                endDate: '9/6/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Italy.html',
                venue: 'Monza',
                description: 'Temple of Speed.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'st-leger-2026',
                name: 'Betfred St Leger Festival',
                startDate: '9/10/2026',
                endDate: '9/13/2026',
                category: 'horseracing',
                url: 'https://www.doncaster-racecourse.co.uk',
                venue: 'Doncaster Racecourse',
                description: 'The world\'s oldest classic.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'madrid-gp-2026',
                name: 'Spanish (Madrid) Grand Prix',
                startDate: '9/11/2026',
                endDate: '9/13/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Spain.html',
                venue: 'Madrid Street Circuit',
                description: 'New standard in F1.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'eng-pak-2026',
                name: 'England v Pakistan Test',
                startDate: '9/11/2026',
                endDate: '9/13/2026',
                category: 'cricket',
                url: 'https://www.ecb.co.uk',
                venue: 'Edgbaston, Birmingham',
                description: 'Late summer cricket action.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'azerbaijan-gp-2026',
                name: 'Azerbaijan Grand Prix',
                startDate: '9/25/2026',
                endDate: '9/27/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Azerbaijan.html',
                venue: 'Baku City Circuit',
                description: 'Tight corners, high speed.',
                status: 'upcoming',
                ticketsAvailable: true
            }
        ]
    },
    {
        month: 'October',
        year: 2026,
        events: [
            {
                id: 'singapore-gp-2026',
                name: 'Singapore Grand Prix',
                startDate: '10/9/2026',
                endDate: '10/11/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Singapore.html',
                venue: 'Marina Bay',
                description: 'The original night race.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'us-gp-austin-2026',
                name: 'United States Grand Prix',
                startDate: '10/23/2026',
                endDate: '10/25/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/United_States.html',
                venue: 'COTA, Austin',
                description: 'F1 in Texas.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'mexico-gp-2026',
                name: 'Mexico City Grand Prix',
                startDate: '10/30/2026',
                endDate: '11/1/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Mexico.html',
                venue: 'Autodromo Hermanos Rodriguez',
                description: 'A fiesta of speed.',
                status: 'upcoming',
                ticketsAvailable: true
            }
        ]
    },
    {
        month: 'November',
        year: 2026,
        events: [
            {
                id: 'sao-paulo-gp-2026',
                name: 'Sao Paulo Grand Prix',
                startDate: '11/6/2026',
                endDate: '11/8/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Brazil.html',
                venue: 'Interlagos',
                description: 'Brazilian flair.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'wta-finals-2026',
                name: 'WTA Finals 2026',
                startDate: '11/7/2026',
                endDate: '11/14/2026',
                category: 'tennis',
                url: 'https://www.wtatennis.com',
                venue: 'Riyadh, Saudi Arabia',
                description: 'Season finale for women\'s tennis.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'atp-finals-2026',
                name: 'Nitto ATP Finals 2026',
                startDate: '11/15/2026',
                endDate: '11/22/2026',
                category: 'tennis',
                url: 'https://www.nittoatpfinals.com',
                venue: 'Turin, Italy',
                description: 'Season finale for men\'s tennis.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'las-vegas-gp-2026',
                name: 'Las Vegas Grand Prix',
                startDate: '11/19/2026',
                endDate: '11/21/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Las_Vegas.html',
                venue: 'Las Vegas Strip',
                description: 'Racing under neon lights.',
                status: 'upcoming',
                ticketsAvailable: true
            },
            {
                id: 'qatar-gp-2026',
                name: 'Qatar Grand Prix',
                startDate: '11/27/2026',
                endDate: '11/29/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Qatar.html',
                venue: 'Lusail Circuit',
                description: 'Penultimate round.',
                status: 'upcoming',
                ticketsAvailable: true
            }
        ]
    },
    {
        month: 'December',
        year: 2026,
        events: [
            {
                id: 'abu-dhabi-gp-2026',
                name: 'Abu Dhabi Grand Prix',
                startDate: '12/4/2026',
                endDate: '12/6/2026',
                category: 'formula1',
                url: 'https://www.formula1.com/en/racing/2026/Abu_Dhabi.html',
                venue: 'Yas Marina Circuit',
                description: 'The season finale.',
                status: 'upcoming',
                ticketsAvailable: true
            }
        ]
    }
];
